import PropTypes from "prop-types"
import React, { useState } from "react"
import { Form, Input, FormFeedback, Label } from "reactstrap"

import LoadingButton from "../../components/Common/LoadingButton"
import AuthLayout from "../../components/Common/AuthLayout"

import { Link } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"

import { toast, Bounce } from "react-toastify"
import { post } from "../../api/axios"
import { toastApiError } from "../../helpers/apiError"
import endpoints from "../../api/endpoints"
import * as Yup from "yup"
import { useFormik } from "formik"

const ForgetPassword = props => {
  document.title = " Forgot Password | AMOK . EARTH"

  const navigate = props.router?.navigate
  const [isSubmitting, setIsSubmitting] = useState(false)

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Please enter your email"),
    }),
    onSubmit: async values => {
      if (isSubmitting) return
      setIsSubmitting(true)
      try {
        const response = await post(endpoints.forgotPassword, {
          email: values.email,
        })

        if (response?.data?.success) {
          localStorage.setItem("reset_email", values.email)
          localStorage.setItem("otp_type", "forgot-password")

          toast.success(response?.data?.message, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          })
          navigate("/verify-otp", {
            state: { email: values.email, otpType: "forgot-password" },
          })
        } else if (response?.response?.data) {
          toastApiError(response)
        }
      } catch (error) {
        toastApiError(error)
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  return (
    <AuthLayout
      title="Forgot Password"
      subtitle="Enter the email address associated with your account, and we'll send you a verification code to verify your identity."
    >
      <Form
        className="auth-page__form"
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <div className="auth-page__field">
          <Label className="auth-page__label">Email</Label>
          <Input
            name="email"
            className="form-control"
            placeholder="Enter your email address"
            type="email"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.email || ""}
            invalid={!!(validation.touched.email && validation.errors.email)}
          />
          {validation.touched.email && validation.errors.email ? (
            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
          ) : null}
        </div>

        <LoadingButton loading={isSubmitting}>Send Reset Link</LoadingButton>

        <p className="auth-page__divider">Or</p>

        <p className="auth-page__footer-text">
          Remember your password?{" "}
          <Link to="/login" className="auth-page__footer-link">
            Login
          </Link>
        </p>
      </Form>
    </AuthLayout>
  )
}

export default withRouter(ForgetPassword)

ForgetPassword.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
}
